import { requireAuthentication } from '../guards.js';

export const path = '/delete-account';
export const component = 'DeleteAccount';
export const thunk = () => requireAuthentication;
